import type { AccountRelatedRow } from '~/services/ContractingService';

import type { AccountNoteAttachment } from './types';

type NoteAttachmentFormat = AccountRelatedRow<'notes_attachments'>['format'];

const FORMAT_LABELS = {
  note: 'Note',
  attachment: 'Attachment',
  file: 'File',
} as const satisfies Record<NonNullable<NoteAttachmentFormat>, string>;

export function noteAttachmentType(format: NoteAttachmentFormat, fileExtension: string | null): string {
  if (format === 'file' && fileExtension) {
    return fileExtension.toUpperCase();
  }

  return format ? FORMAT_LABELS[format] : FORMAT_LABELS.file;
}

export function toAccountNoteAttachment(row: AccountRelatedRow<'notes_attachments'>): AccountNoteAttachment {
  return {
    id: row.external_refs.salesforce,
    lastModifiedDate: row.last_modified_at,
    title: row.title,
    type: noteAttachmentType(row.format, row.file_extension),
  };
}
